import { Col, Row, Stack, Alert, Container } from "react-bootstrap";
import BikeStatus from "../components/Bicycles/BikeStatus";
import ShowMap from "../components/Droppoint/ShowMap";
import Revenue from "../components/Revenue/Revenue";
import Rides from "../components/Rides/Rides";
import DamageRepports from "../components/SchadeMeldingen/DamageReppots";
import SliderDroppoints from "../components/SliderDroppoint/SliderDroppoint";
import Users from "../components/Users/Users";
import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import LongRentals from "../components/LongRentals/LongRentals";

const CustomerDashboard = () => {
  const { apiKey } = useParams();
  const [tenantData, setTenantData] = useState([]);
  const [revenue, setRevenue] = useState(false);
  const [userRegistrations, setUserRegistrations] = useState(false);
  const [bikeStatus, setBikeStatus] = useState(false);
  const [rides, setRides] = useState(false);
  const [damageRepports, setDamageRepports] = useState(false);
  const [droppoints, setDroppoints] = useState(false);
  const [longRentals, setLongRentals] = useState(false);

  useEffect(() => {
    axios
      .get("api/Tenant/GetTenantId/" + apiKey)
      .then((response) => {
        setTenantData(response.data);
        var tenantId = response.data.tenantID;
        axios
          .get("api/TenantWidgets/TenantWidgetsIsActive/" + apiKey)
          .then((response) => {
            var tenants = response.data;
            tenants.forEach((tenant) => {
              if (tenant.name === "Revenue" && tenant.isActive) {
                setRevenue(true);
              }
              if (tenant.name === "UserRegistrations" && tenant.isActive) {
                setUserRegistrations(true);
              }
              if (tenant.name === "BikeStatus" && tenant.isActive) {
                setBikeStatus(true);
              }
              if (tenant.name === "Rides24h" && tenant.isActive) {
                setRides(true);
              }
              if (tenant.name === "DamageReports" && tenant.isActive) {
                setDamageRepports(true);
              }
              if (tenant.name === "Droppoints" && tenant.isActive) {
                setDroppoints(true);
              }
              if (tenant.name === "LongRentals" && tenant.isActive) {
                setLongRentals(true);
              }
            });
          })
          .catch((error) => {
            console.log("error tenant widget");
          });
      })
      .catch((error) => {
        console.log("error tenant Api");
      });
  }, []);

  return (
    <>
      <div
        className="overflow-hidden d-flex ps-2"
        style={{ backgroundColor: "rgb(0, 177, 255)" }}
      >
        {droppoints ? (
          <>
            <Col sm={8} className="pt-2">
              <Alert style={{ backgroundColor: "#fff" }}>
                <h1 className="fw-bold text-right">{tenantData.tenantName}</h1>
              </Alert>
              <div className="d-flex" style={{ alignItems: "top" }}>
                <Col sm={10} className="pe-2">
                  <Row className="mb-2 d-flex">
                    <Stack direction="horizontal" gap={2}>
                      {revenue && (
                        <Col>
                          <Revenue />
                        </Col>
                      )}
                      {userRegistrations && (
                        <Col>
                          <Users />
                        </Col>
                      )}
                      {bikeStatus && (
                        <Col>
                          <BikeStatus />
                        </Col>
                      )}
                      {rides && (
                        <Col>
                          <Rides />
                        </Col>
                      )}
                    </Stack>
                  </Row>

                  {damageRepports && (
                    <Row>
                      <Col className="pe-2">
                        <DamageRepports />
                      </Col>
                    </Row>
                  )}

                  {longRentals && (
                    <Row>
                      <Col>
                        <LongRentals />
                      </Col>
                    </Row>
                  )}
                </Col>
                {droppoints && (
                  <Col sm={2} className="ms-2" style={{ height: "full" }}>
                    <SliderDroppoints />
                  </Col>
                )}
              </div>
            </Col>
            <Col xs={4}>
              <ShowMap />
            </Col>
          </>
        ) : (
          <>
            <Col sm={8} className="pt-2">
              <Alert style={{ backgroundColor: "#fff" }}>
                <h1 className="fw-bold text-right">{tenantData.tenantName}</h1>
              </Alert>
              <Row className="mb-2">
                <Stack direction="horizontal" gap={3}>
                  {revenue && (
                    <Col>
                      <Revenue />
                    </Col>
                  )}
                  {userRegistrations && (
                    <Col>
                      <Users />
                    </Col>
                  )}
                  {bikeStatus && (
                    <Col>
                      <BikeStatus />
                    </Col>
                  )}
                  {rides && (
                    <Col>
                      <Rides />
                    </Col>
                  )}
                </Stack>
              </Row>

              {damageRepports && (
                <Row>
                  <Col>
                    <DamageRepports />
                  </Col>
                </Row>
              )}

              {longRentals && (
                <Row>
                  <Col>
                    <LongRentals />
                  </Col>
                </Row>
              )}
            </Col>
            <Col sm={4}>
              <ShowMap />
            </Col>
          </>
        )}
      </div>
    </>
  );
};
export default CustomerDashboard;
